module.exports = __webpack_public_path__ + "img/arrow-green.f0a3c0a7.svg";